import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import PersonAvatar from '../common/PersonAvatar';

/** A person in a table row — photo (or initials), name, and a muted line under it. */
const PersonCell: React.FC<{
  name?: string | null;
  photoFilename?: string | null;
  secondary?: React.ReactNode;
}> = ({ name, photoFilename, secondary }) => (
  <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0 }}>
    <PersonAvatar name={name} photoFilename={photoFilename} size={32} />
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="body2" fontWeight={600} noWrap>{name || '—'}</Typography>
      {secondary && (
        <Typography component="div" variant="caption" color="text.secondary" noWrap>{secondary}</Typography>
      )}
    </Box>
  </Stack>
);

export default PersonCell;
